<script setup>
import SalaryList from '@/components/Salary/SalaryList.vue';
export default {
    components: { SalaryList },
};
</script>

<template>
    <div>
        <SalaryList />
    </div>
</template>

<style scoped lang="scss"></style>
